import React, { useState } from "react";
import { Button } from "@/aible";
import { createTone, getToneList } from "@/containers/ChatTone/reducer";
import { toast } from "react-toastify";
import * as chatGPTReducer from "../../../containers/ChatGPT/reducer";
import { useDispatch, useSelector } from "@/types/store";
import { getSelectedFolder } from "@/containers/Folders/reducer";
import styles from "../style.module.css";
import { CreateToneView } from "./CreateToneView";
import { ChatToneView } from "./ChatToneView";
const ToneSettings = ({ onlyViewSelectedTonePrompt, selectedTonePromptModelOverride }) => {
    const dispatch = useDispatch();
    const [isCreatingTone, updateIsCreatingTone] = useState(false);
    const updateChatTone = (toneId) => {
        dispatch(chatGPTReducer.updateChatTone(toneId));
    };
    const folderId = useSelector((state) => getSelectedFolder(state));
    const chatTone = useSelector((state) => chatGPTReducer.getChatTone(state));
    const chatTones = useSelector((state) => getToneList(state));
    const selectedChatTone = chatTones.find((tone) => tone?.id === chatTone) ?? chatTones[0];
    const chatToneText = useSelector((state) => chatGPTReducer.getChatToneText(state, selectedTonePromptModelOverride));
    const exportSavedChatTone = () => {
        const retLabel = selectedChatTone.name;
        const exportTone = {
            name: retLabel,
            metadata: {
                values: selectedChatTone.metadata.values
            }
        };
        toast(`Tone: ${selectedChatTone.name} copied to clipboard.`, {
            type: toast.TYPE.SUCCESS,
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3500
        });
        navigator.clipboard.writeText(JSON.stringify(exportTone));
    };
    if (onlyViewSelectedTonePrompt) {
        return (React.createElement("div", { className: " w-[100%] mb-[4px]" },
            React.createElement("textarea", { className: styles.selectedTonePreviewTextArea, style: { height: "120px", backgroundColor: "white" }, value: chatToneText, disabled: true })));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
            } },
            React.createElement("div", null, isCreatingTone ? "Create A New Tone" : "Edit Chat Tones"),
            React.createElement("div", { style: { display: "flex", justifyContent: "space-between", gap: "10px" } },
                React.createElement(Button, { type: "secondary", onClick: exportSavedChatTone }, "Export Tone"),
                React.createElement(Button, { type: "secondary", onClick: () => {
                        updateIsCreatingTone(true);
                    }, disabled: isCreatingTone }, "Create New Tone"),
                React.createElement(Button, { type: "secondary", onClick: () => {
                        navigator.clipboard.readText().then((importedTone) => {
                            if (importedTone) {
                                try {
                                    const parsedTone = JSON.parse(importedTone);
                                    parsedTone.folder_id = folderId;
                                    dispatch(createTone(parsedTone)).then((tone) => {
                                        updateChatTone(tone?.id);
                                        toast(`Tone: ${tone?.name} was imported.`, {
                                            type: toast.TYPE.SUCCESS,
                                            position: toast.POSITION.TOP_CENTER,
                                            autoClose: 3500
                                        });
                                    });
                                }
                                catch (e) {
                                    console.log(e);
                                    toast(`${e}`, {
                                        type: toast.TYPE.ERROR,
                                        position: toast.POSITION.TOP_CENTER,
                                        autoClose: 3500
                                    });
                                }
                            }
                        });
                    }, disabled: isCreatingTone }, "Import Tone"))),
        React.createElement("div", { className: styles.chatToneEditBody }, isCreatingTone ? (React.createElement(CreateToneView, { updateIsCreatingTone: updateIsCreatingTone })) : (React.createElement(ChatToneView, { tone: selectedChatTone })))));
};
export default ToneSettings;
